import { SHARE_USER_FILTER_AND_COLUMNS } from "../../../gql/bookingapi";

export const buildFilterAssignmentRemovalInput = ({
  filterName,
  filterUserID,
  columnSetName,
  columnSetUserID,
  groupIds = [],
}) => ({
  previousFilterId: filterName && filterName !== "-" ? `EQUIPMENTLIST#${filterName}` : null,
  previousFilterUserID: filterUserID ?? null,
  previousColumnSetId: columnSetName && columnSetName !== "-" ? `EQUIPMENTLIST#${columnSetName}` : null,
  previousColumnSetUserID: columnSetUserID ?? filterUserID ?? null,
  groupIds: (groupIds || []).filter(Boolean),
});

export const removeFilterAssignment = ({ client, ...assignment }) =>
  client.mutate({
    mutation: SHARE_USER_FILTER_AND_COLUMNS,
    variables: {
      input: buildFilterAssignmentRemovalInput(assignment),
    },
    fetchPolicy: "no-cache",
  });